<template>
  <div class="home-container" ref="homeContainer" v-cloak>
    <nav-bar @toPartner="toPartner"></nav-bar>
    <banner></banner>
    <product-center></product-center>
    <solution></solution>
    <advantage></advantage>
    <partner ref="partnerDiv"></partner>
    <about-us></about-us>
    <customize></customize>
    <page-footer @toPartner="toPartner"></page-footer>
  </div>
</template>

<script>
import navBar from "../common/navBar";
import banner from "./components/banner";
import productCenter from "./components/productCenter";
import solution from "./components/solution";
import advantage from "./components/advantage";
import partner from "./components/partner";
import aboutUs from "./components/aboutUs";
import customize from "../common/customize";
import pageFooter from "../common/pageFooter";

export default {
  components: {
    navBar,
    banner,
    productCenter,
    solution,
    advantage,
    partner,
    aboutUs,
    customize,
    pageFooter,
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
    if (this.$route.query.to == "partner") {
      this.toPartner();
    }
  },
  methods: {
    toPartner() {
      this.$nextTick(() => {
        document
          .getElementById("partnerComtainer")
          .scrollIntoView({ block: "start", behavior: "smooth" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  min-width: 1100px;
}
</style>
<style>
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue